// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"_4lHdY9AbhGoGc8Nt5JNoO"};